import { Price } from '@shared/models/price.model';
import { OrderHistoryItem } from './order-history.model';
import { OrderStatus } from '@app/sales/models/sps-order-item.model';

export class InFlightOrder extends OrderHistoryItem {
  orderId: number;
  description: string;
  offeringId: string;
  orderItemType: InFlightOrderItemTypes;
  orderStatus: OrderStatus;
  equipmentType?: EquipmentType;
  costOfGoodsSold?: Price;
  aNumber: string;
  icc?: string;
  startDate?: string;
}

export enum EquipmentType {
  Handset = 'Handset',
  Accessory = 'Accessory',
}

export enum InFlightOrderItemTypes {
  CreateSubscription = 'CreateSubscription',
  CreateSubscriptionV2 = 'CreateSubscriptionV2',
  ChangeSubscription = 'ChangeSubscription',
  TransferSubscription = 'TransferSubscription',
  TerminateSubscription = 'TerminateSubscription',
  AddEquipment = 'AddEquipment',
  AddSlaveSim = 'AddSlaveSim',
  AddService = 'AddService',
}
